<div class="dynamic-field-container" [class.selected]="config?.selected">
  <div
    class="dynamic-field form-input text-align"
    [formGroup]="group"
    [hidden]="!config?.isFormBuilder && config?.options?.hidden"
  >
    <!-- <ups-job-search></ups-job-search> -->
    <ups-dynamic-helper-label
      [config]="config"
      [dynamicService]="dynamicService"
    ></ups-dynamic-helper-label>
    <div class="job-search-container" style="position: relative">
      @if (!config?.options?.isMultiSelect) {
        <kendo-dropdownlist
          #dropdown
          class="k-no-dropdown w-100"
          [attr.name]="config.formControlName"
          [formControlName]="config.formControlName"
          [valuePrimitive]="false"
          [textField]="'Name'"
          [valueField]="'Name'"
          [defaultItem]="{ Name: config?.placeholder }"
          [filterable]="true"
          (valueChange)="valueChangeItem($event)"
          search-ex
          [seSearchColumns]="['FullName', 'Email']"
          (seFilterChangeEx)="filterChangeItem($event)"
          [seDebounceFilterChange]="150"
          [seUseCustomLocalFilter]="true"
          [seMinSearchLength]="0"
          [loading]="isLoading"
          [tabindex]="tabindex"
        >
          <ng-template kendoDropDownListItemTemplate let-dataItem>
            <div
              style="display: inline-flex"
              [hidden]="dataItem?.Name === config?.placeholder"
            >
              @if (dataItem.JobID) {
                <span (click)="toggleFavorite(dataItem, $event)">
                  <i
                    class="fas fa-star"
                    title="Add/Remove Favorite Job"
                    [ngStyle]="{
                      color: dataItem.IsUserFavorite ? 'orange' : 'lightgrey',
                    }"
                  ></i>
                  &nbsp;
                </span>
              }
              @if (dataItem.JobID && showFacilityTooltip) {
                <span kendoTooltip [tooltipTemplate]="facilityTooltip">
                  <i class="fa fa-info-circle" title></i>
                  &nbsp;
                </span>
              }

              <ng-template #facilityTooltip>
                <div>Active Jobs:</div>
                @if (dataItem.FacilityActiveJobs.length === 0) {
                  <div>N/A</div>
                }
                @for (job of dataItem.FacilityActiveJobs; track job) {
                  <div>{{ job }}</div>
                }
              </ng-template>
              <div>
                @if (dataItem.JobID) {
                  <span class="font-weight-bold">
                    {{ dataItem.JobID }}
                  </span>
                  <span>{{ ' - ' }}</span>
                }
                @if (dataItem.Name) {
                  <span class="job-name">
                    {{ dataItem.Name }}
                  </span>
                }
                @if (!dataItem.IsActive && dataItem.JobID) {
                  <span class="text-danger">(Closed)</span>
                }
              </div>
            </div>
          </ng-template>
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            <div style="display: inline-flex">
              <div kendoTooltip [title]="dataItem?.Name">
                @if (dataItem.JobID) {
                  <span class="font-weight-bold">{{ dataItem.JobID }} -</span>
                }

                <span class="job-name">{{ dataItem.Name || '' }}</span>
              </div>
            </div>
          </ng-template>
        </kendo-dropdownlist>
      }
      @if (config?.options?.isMultiSelect) {
        <kendo-multiselect
          upsKeepSelectionOnEsc
          [attr.name]="config.formControlName"
          [formControlName]="config.formControlName"
          class="k-no-dropdown w-100"
          [valuePrimitive]="false"
          [textField]="'JobID'"
          [valueField]="'JobID'"
          [placeholder]="config?.placeholder"
          [filterable]="true"
          (valueChange)="multiSelectValueChange($event)"
          search-ex
          [seSearchColumns]="['FullName', 'Email']"
          (seFilterChangeEx)="filterChangeItem($event)"
          [seDebounceFilterChange]="150"
          [seUseCustomLocalFilter]="true"
          [seMinSearchLength]="0"
          [loading]="isLoading"
          [tabindex]="tabindex"
        >
          <ng-template kendoMultiSelectItemTemplate let-dataItem>
            <div style="display: inline-flex">
              @if (dataItem.JobID) {
                <span (click)="toggleFavorite(dataItem, $event)">
                  <i
                    class="fas fa-star"
                    title="Add/Remove Favorite Job"
                    [ngStyle]="{
                      color: dataItem.IsUserFavorite ? 'orange' : 'lightgrey',
                    }"
                  ></i>
                  &nbsp;
                </span>
              }
              @if (dataItem.JobID && showFacilityTooltip) {
                <span kendoTooltip [tooltipTemplate]="facilityTooltip">
                  <i class="fa fa-info-circle" title></i>
                  &nbsp;
                </span>
              }

              <ng-template #facilityTooltip>
                <div>Active Jobs:</div>

                @if (dataItem.FacilityActiveJobs.length === 0) {
                  <div>N/A</div>
                }
                @for (job of dataItem.FacilityActiveJobs; track job) {
                  <div>{{ job }}</div>
                }
              </ng-template>
              <div>
                @if (dataItem.JobID) {
                  <span class="font-weight-bold">
                    {{ dataItem.JobID }}
                  </span>
                  <span>{{ ' - ' }}</span>
                }
                @if (dataItem.Name) {
                  <span class="job-name">
                    {{ dataItem.Name }}
                  </span>
                }
                @if (!dataItem.IsActive && dataItem.JobID) {
                  <span class="text-danger">(Closed)</span>
                }
              </div>
            </div>
          </ng-template>
          <ng-template kendoMultiSelectValueTemplate let-dataItem>
            <div style="display: inline-flex">
              <div kendoTooltip [title]="dataItem?.JobID">
                <span class="job-name">
                  {{ dataItem.JobID ? dataItem.JobID + ' - ' : '' }}
                </span>
              </div>
            </div>
          </ng-template>
        </kendo-multiselect>
      }
    </div>
    <ups-dynamic-search-error [show]="searchError"></ups-dynamic-search-error>
    @if (config?.isFormBuilder) {
      <div [class.hidden]="config?.options?.hidden"></div>
    }
  </div>
  @if (config?.isFormBuilder) {
    <div class="form-builder-options">
      <i class="fas fa-times ms-3 cursor-pointer c-red" (click)="delete()"></i>
      <!-- <i class="fas fa-bars ms-3 cursor-grab"></i> -->
    </div>
  }
</div>
